import React, { useEffect, useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
// import useUsers from "../../../hooks/use-users";

import { DataGrid, Icon } from "../../../components";
import {
	CustomButton,
	CustomDialog,
	CustomSelect,
	FeaturedIcon,
	FormElement,
	FormikTextField,
	MultiSelect,
} from "../../../components";

import css from "./modals.module.css";
import RebatesClient from "../../../RebatesClient";
import { useMutation } from "../../../hooks/use-mutation";
import { Alert, Checkbox, IconButton, Snackbar } from "@mui/material";
import ModalUserRemove from "./modal-user-remove";
import useUsers from "../../../hooks/use-users";
import ModalValleyRepUnassign from "./modal-valley-rep-unassign";

const ModalValleyRep = ({
	open,
	onClose,
	selectedUser,
	account,
	valleyUsers,
	valleyRefetchUsers,
}) => {
	// console.log(account)
	// const { valleyUsers, valleyRefetchUsers } = useUsers()

	const [showValleyRepUnassignModal, setShowValleyRepUnassignModal] =
		useState(false);
	const [snackbar, setSnackbar] = useState(null);
	const handleCloseSnackbar = () => setSnackbar(null);
	const [newUserId, setNewUserId] = useState(-1);

	const valleyRepForAcct = valleyUsers
		?.find((vu) => vu.id === selectedUser?.id)
		?.assigned_accounts?.find((rep) => rep.account_id === account?.id);

	// console.log(valleyRepForAcct)
	const parentAccountIds = [
		account?.id, // Exclude users assigned to the current account
		account?.parent_account?.id,
		account?.parent_account?.parent_account_id,
		account?.parent_account?.parent_account?.parent_account_id,
	]?.filter((acct) => acct);

	const childAccountIds =
		account.children_accounts?.flatMap((child) => {
			const collectIds = (account) => {
				const ids = [account.id];
				if (account.children_accounts?.length) {
					ids.push(...account.children_accounts.flatMap(collectIds));
				}
				return ids;
			};
			return collectIds(child);
		}) || [];

	//don't include valmont rep if they are assigned to any parent accounts or child accounts.
	const filteredReps = valleyUsers?.filter((user) => {
		return !user.assigned_accounts.some((assignedAccount) => {
			// console.log('user', user.first_name)

			return (
				parentAccountIds.includes(assignedAccount.account_id) ||
				childAccountIds.includes(assignedAccount.account_id)
			);

			// return parentAccountIds.includes(assignedAccount.account_id)
		});
	});

	const { mutateAsync: submitRequest, isLoading } = useMutation({
		mutationKey: "saveValleyUser",
		networkMode: "always",
		mutationFn: async (updatedData) =>
			await RebatesClient.updateValleyRepAssignment(updatedData),
		onError: (err) => {
			console.log(err);
		},
		onSuccess: (resp) => {
			if (resp?.response?.status == 200) {
				// close()
				valleyRefetchUsers();
			} else {
				alert(`${resp.body.status}`);
			}
		},
	});

	const { mutateAsync: submitAlertRequest, isAlertReqLoading } = useMutation({
		mutationKey: "saveValleyUser",
		networkMode: "always",
		mutationFn: async (updatedData) =>
			await RebatesClient.updateValleyRepFarmEmailAlert(updatedData),
		onError: (err) => {
			console.log(err);
		},
		onSuccess: (resp) => {
			if (resp?.response?.status == 200) {
				// close()
				setSnackbar({ children: "Save complete", severity: "success" });
				valleyRefetchUsers();
			} else {
				alert(`${resp.body.status}`);
			}
		},
	});

	function close() {
		setShowValleyRepUnassignModal(false);
		onClose();
	}

	const getDisabledFarmAlertForRow = (row) => {
		const alert = valleyRepForAcct?.disabled_farm_alerts?.find(
			(alert) => alert.farm_account_id === row.id
		);
		// console.log("getDisabledFarmAlertForRow", alert)
		return alert;
	};

	const title = (
		<div className={css.modalTitle}>
			<FeaturedIcon icon="User" />
			{selectedUser?.id
				? `Edit Rep: ${selectedUser.first_name} ${selectedUser.last_name}`
				: "Assign Valley Rep"}
		</div>
	);
	// console.log(flattenAccts(account))
	const findAccountById = (id) => {
		// console.log([findAccountById(findAccountById(params?.row?.parent_account_id)?.parent_account_id)?.name, findAccountById(params?.row?.parent_account_id)?.name])
		return flattenAccts(account)?.find((acct) => acct?.id === id);
	};

	const columns = [
		// {
		//   field: "parent_account1",
		//   headerName: "Parent Account",
		//   renderCell: (params) => (
		//     <div>{`${findAccountById(findAccountById(params?.row?.parent_account_id)?.parent_account_id)?.name || ""}`}</div>
		//   ),
		// },
		{
			field: "parent_account",
			headerName: "Parent Account(s)",
			renderCell: (params) => {
				const parentAcct = findAccountById(
					params?.row?.parent_account_id
				);
				const grandParentAcct = parentAcct
					? findAccountById(parentAcct?.parent_account_id)
					: null;
				const greatGrandParentAcct = grandParentAcct
					? findAccountById(grandParentAcct?.parent_account_id)
					: null;

				const combinedAccts = [
					greatGrandParentAcct,
					grandParentAcct,
					parentAcct,
				]
					.filter((acct) => acct?.account_type == "SUB_ENTITY")
					.map((acct) => acct?.name)
					.join(" / ");

				return <div>{combinedAccts}</div>;
			},
		},
		{
			field: "farm",
			headerName: "Farm",
			renderCell: (params) => <div>{`${params?.row?.name}`}</div>,
		},
		{
			field: "action",
			headerName: "Email Alerts Enabled",
			sortable: false,
			align: "right",
			renderCell: (params) => {
				return (
					<>
						<Checkbox
							checked={
								!getDisabledFarmAlertForRow(params.row)
									? true
									: false
							}
							onClick={(e) => {
								// console.log("valleyRepForAcct", valleyRepForAcct);
								submitAlertRequest({
									rep_disabled_farm_alert_id:
										getDisabledFarmAlertForRow(params.row)
											?.rep_disabled_farm_alert_id,
									user_to_account_id:
										valleyRepForAcct?.user_to_account_id,
									alertEnabled: e.target.checked,
									farm_account_id: params.row.id,
								});
							}}
						></Checkbox>
					</>
				);
			},
		},
	];

  return (

    <>
      <CustomDialog open={showValleyRepUnassignModal ? false : open} onClose={onClose} width={640} title={title}>
        <div style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}>

          <div style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            // overflowY: "auto",
          }}>
            {selectedUser?.id && (
              <div>
                <CustomButton
                  type="submit"
                  label={`Unassign ${selectedUser?.first_name} from ${account?.name}`}
                  onClick={() => {
                    setShowValleyRepUnassignModal(true);
                  }}
                  color="primary"
                  style={{
                    width: 'auto',
                  }}
                />
              </div>
            )}

            {!selectedUser?.id && (
              <>
                <div>
                  Note: Reps already assigned to parent or child
                  account are excluded from this list below.
                </div>
                <CustomSelect
                  label="Valley Rep"
                  name="user_role"
                  value={newUserId}
                  onChange={(e) => {
                    setNewUserId(e.target.value);
                  }}
                  options={[
                    {
                      value: -1,
                      name: "Select a Valley Rep",
                      id: -1,
                      disabled: true,
                    },
                    ...(filteredReps?.map((user) => ({
                      id: user.id,
                      name: `${user.first_name} ${user.last_name}`,
                      value: user.id,
                    })) || []),
                  ]}
                  halfWidth
                />
              </>
            )}

            <div style={{ flex: 1 }}>
              {selectedUser?.id && (
                <DataGrid
                  hideFooter={true}
				  slots={{ toolbar: () => (<div style={{fontFamily: 'Inter', fontStyle: 'bold', padding: '10px'}}><strong>Farm Email Alerts</strong></div>) }}

                  onRowClick={(params) => {
                    // console.log("Row clicked", params);
				  }}
				  rows={flattenAccts(account).filter(
					(farm) => farm.account_type === "FARM"
				  )}
				  columns={columns}
				  sx={{
					maxHeight: 250,
					overflowY: "auto",
				  
                    // 'display': 'inline',
                    "& .MuiDataGrid-columnSeparator": {
                      display: "none",
                    },
                  }}
                />
              )}
            </div>
          </div>
          

					<div className={css.actions}>
						{selectedUser?.id ? <div></div> : null}

						<CustomButton
							label="Close"
							onClick={onClose}
							color="secondary"
						/>

						{!selectedUser?.id && (
							<CustomButton
								type="submit"
								label={"Add"}
								onClick={async () => {
									if (!selectedUser?.id && newUserId == -1) {
										alert(
											"Please select a Valley Rep to add"
										);
										return;
									}
									const userId =
										selectedUser?.id || newUserId;
									await submitRequest({
										user_to_account_id: null,
										account_id: account?.id,
										user_id: newUserId,
										action: "assign",
									});
									close();
								}}
								color="primary"
							/>
						)}
					</div>
				</div>
			</CustomDialog>

			<ModalValleyRepUnassign
				open={showValleyRepUnassignModal}
				valleyUser={selectedUser}
				// activeUser={activeUser}
				account={account}
				valleyRepForAcct={valleyRepForAcct}
				onremoveComplete={() => {
					close();
				}}
				onClose={() => {
					//don't call modal-user on close beacuse we just want to close the remove modal
					setShowValleyRepUnassignModal(false);
				}}
			/>

			{!!snackbar && (
				<Snackbar
					open
					anchorOrigin={{ vertical: "top", horizontal: "center" }}
					onClose={handleCloseSnackbar}
					autoHideDuration={6000}
				>
					<Alert {...snackbar} onClose={handleCloseSnackbar} />
				</Snackbar>
			)}
		</>
	);
};

const flattenAccts = (data) => {
	// console.log(data)
	const flattenAccounts = (accounts) => {
		return accounts.reduce((acc, account) => {
			// if (account.account_type === "FARM") {
			acc.push(account);
			// }
			if (account.children_accounts?.length) {
				acc.push(...flattenAccounts(account.children_accounts));
			}
			if (account.parent_account) {
				acc.push(account.parent_account);
			}
			return acc;
		}, []);
	};

	return flattenAccounts([data]);
};

export default ModalValleyRep;
